
import * as React from 'react';
import { useEffect } from 'react';
import { Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useCheckAuth } from 'ra-core';
import { ForgotPasswordForm } from './ForgotPasswordForm';

export const ForgotPassword = (props) => {
    const rest = { ...props };
    delete rest.children;
    delete rest.backgroundImage;
    const checkAuth = useCheckAuth();
    const navigate = useNavigate();
    useEffect(() => {
        checkAuth({}, false)
            .then(() => {
                // already authenticated, redirect to the home page
                navigate('/');
            })
            .catch(() => {
                // not authenticated, stay on the login page
            });
    }, [checkAuth, navigate]);

    return (
        <Root {...rest} >
            <Card className={LoginClasses.card}>
                <div className={LoginClasses.avatar}>
                    <Typography variant='h6'>Forgot password</Typography>
                </div>
               <ForgotPasswordForm /> 
            </Card>
        </Root>
    );
};


const PREFIX = 'RaForgot';
export const LoginClasses = {
    card: `${PREFIX}-card`,
    avatar: `${PREFIX}-avatar`,
    icon: `${PREFIX}-icon`,
};

const Root = styled('div', {
    name: PREFIX,
    overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '1px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundImage: 'radial-gradient(circle at 50% 14em, #6fcf5f 0%, #1f842d 60%, #13701f 100%)',
    [`& .${LoginClasses.card}`]: {
        minWidth: 300,
        marginTop: '6em',
    },
    [`& .${LoginClasses.avatar}`]: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    [`& .${LoginClasses.icon}`]: {
        backgroundColor: theme.palette.secondary[500],
    },
}));
